import { Action } from '@ngrx/store';

export enum DriverTypeActionTypes {
  UpdateDriverType = '[DriverType] Update Driver Type',
}

export class UpdateDriverType implements Action {
  public readonly type = DriverTypeActionTypes.UpdateDriverType;

  constructor(
    public payload: {
      driverType: string;
    }
  ) {}
}

export type DriverTypeActions = UpdateDriverType;
